import React from 'react';
import PropTypes from 'prop-types';

/**
 * Container for Table.
 *
 * Usage:
 *
 * ```jsx
 * import { TableContainer } from '@one-thd/sui-atomic-components';
 * ```
 */
const TableContainer = React.forwardRef((props, ref) => {
  const {
    component,
    ...other
  } = props;

  const cls = 'sui-w-full sui-overflow-x-auto';

  const Root = component || 'div';

  return (
    <Root
      ref={ref}
      as={component}
      className={cls}
      {...other}
    />
  );
});

TableContainer.displayName = 'TableContainer';

TableContainer.propTypes = {
  /**
   * The content of the component, normally `Table`.
   */
  children: PropTypes.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
};

export { TableContainer };